"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLockFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.lock_filled_svg__cls-1{display:none}')),
        React.createElement("path", { className: "lock_filled_svg__cls-1", d: "M0 0h32v32H0z", id: "lock_filled_svg__transparent_box" }),
        React.createElement("g", { id: "lock_filled_svg__FILLED" },
            React.createElement("path", { className: "lock_filled_svg__cls-1", d: "M20 7.09c0-1.31-.22-1.67-.54-2.06-.57-.66-1.79-1-3.46-1s-2.91.37-3.47 1c-.32.38-.53.73-.53 2.06V12h8z" }),
            React.createElement("path", { d: "M22 12V7.09a4.59 4.59 0 00-1-3.35C20 2.6 18.3 2 16 2s-4 .6-5 1.74a4.6 4.6 0 00-1 3.35V12H6v15.13l.44.3A18.14 18.14 0 0016 30a18.14 18.14 0 009.56-2.57l.44-.3V12zm-5 8.94V24h-2v-3.06A2.17 2.17 0 0113.82 19a2.2 2.2 0 114.4 0A2.17 2.17 0 0117 20.94zM12 12V7.09c0-1.33.21-1.68.53-2.06.56-.66 1.79-1 3.47-1s2.89.37 3.46 1c.32.39.54.75.54 2.06V12z" }))));
}
exports.default = SvgLockFilled;
//# sourceMappingURL=LockFilled.js.map